export default __webpack_public_path__ + "static/logo_blanc@2x-ba07a5815668cd79c06b0f2479004798.png";